import React, { Component } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'

import createResource from '../utils/create-resource'
import fetchResources from '../utils/fetch-resources'
import handleInputChange from '../utils/handle-input-change'

class BookCreationModal extends Component {
  state = {}

  componentDidMount() {
    fetchResources('entities')
  }

  createBook() {
    const entityID = this.state.entityID
    const creationParams = [{ key: 'currency', value: this.state.currency }]
    const optionalParams = ['id', 'default']
    for (let i = 0; i < optionalParams.length; i++) {
      const key = optionalParams[i]
      const value = this.state[key]
      if (value != null) {
        creationParams.push({ key: key, value: value })
      }
    }
    createResource(
      this.props.services.api + '/entities/' + entityID + '/books',
      creationParams,
      () => {
        fetchResources('books')
        this.props.toggleBookCreationModal()
      }
    )
  }

  render() {
    return (
      <Modal
        id='application.books.bookCreation'
        show={this.props.showBookCreationModal}
        onHide={this.props.toggleBookCreationModal}
      >
        <Modal.Header>
          <Modal.Title className='h5'>Add book</Modal.Title>
          <Button
            className='close'
            onClick={this.props.toggleBookCreationModal}
            id='application.books.bookCreation.closeButton'
          >
            <i className='material-icons'>close</i>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='row align-items-center'>
            <Form.Label className='col-3'>Entity</Form.Label>
            <Form.Control
              as='select'
              id='application.books.bookCreation.entityIDInput'
              name='entityID'
              onChange={handleInputChange.bind(this)}
              className='col'
              defaultValue='placeholder'
            >
              <option value='placeholder' disabled hidden>
                Entity
              </option>
              {this.props.entities.map(entity => {
                return (
                  <option key={entity.id} value={entity.id}>
                    {entity.name || entity.id}
                  </option>
                )
              })}
            </Form.Control>
          </Form.Group>
          <Form.Group className='row align-items-center'>
            <Form.Label className='col-3'>ID</Form.Label>
            <Form.Control
              id='application.books.bookCreation.idInput'
              className='col'
              type='text'
              name='id'
              onChange={handleInputChange.bind(this)}
              placeholder='Optional book ID'
            />
          </Form.Group>
          <Form.Group className='row align-items-center'>
            <Form.Label className='col-3'>Currency</Form.Label>
            <Form.Control
              as='select'
              id='application.books.bookCreation.currencyInput'
              name='currency'
              onChange={handleInputChange.bind(this)}
              className='col'
              defaultValue='placeholder'
            >
              <option value='placeholder' disabled hidden>
                Currency
              </option>
              {this.props.categoricals.currency.map(currency => {
                return (
                  <option key={currency.value} value={currency.value}>
                    {currency.name}
                  </option>
                )
              })}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Check
              id='application.books.bookCreation.defaultInput'
              name='default'
              type='checkbox'
              label='Set as the default book?'
              onChange={handleInputChange.bind(this)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='primary'
            onClick={() => this.createBook()}
            id='application.books.bookCreation.submitButton'
          >
            Add book
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    categoricals: state.default.categoricals,
    entities: state.default.entities,
    services: state.default.services
  }
}

export default connect(mapStateToProps)(BookCreationModal)
